import { AuthenticatedLayout } from "../../../../layouts";
import { CRADueRemittanceTransacitons } from "../../../../components/DirectDeposit/Transactions/CRADueRemittance";
import { FC } from "react";

export interface ICRADueRemittanceTransacitonsPage { }

export const CRADueRemittanceTransacitonsPage: FC<ICRADueRemittanceTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="CRA Due"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<CRADueRemittanceTransacitons />}
		/>
	);
};
